import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_PARAMETER_BACKUP_REQUEST } from './constants';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';
import { notify } from 'sharedComponents/GeneralNotification';
import { getParameterBackupAction } from './actions';
import { DEFAULT_FILE_TYPE } from '../../../../../../PowertrainAssetDetails/DetailedInformation/Header/ParameterBackupV2/constants';
function* gatewayParameterbackupSaga(action) {
    yield put(getParameterBackupAction(apiCallStatus.LOADING));
    try {
        const fileType = action?.fileType?.toLowerCase() || DEFAULT_FILE_TYPE;
        yield call(GatewayManagementApi.getParameterBackup, action.assetId, fileType);
        yield put(getParameterBackupAction(apiCallStatus.SUCCESS));
        notify(translate('ABB.Powertrain.Frontend.ParameterBackupSuccessMessage'), NOTIFICATION_TYPES.SUCCESS);
    } catch (error) {
        yield put(getParameterBackupAction(apiCallStatus.ERROR, [], error));
    }
}
export function* ParameterBackupWatchers() {
    yield takeLatest(GET_PARAMETER_BACKUP_REQUEST, gatewayParameterbackupSaga);
}
